exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".realname-auth-form[data-v-5e0370e7]{padding:10px 0}", ""]);

// exports
